import axios from '../plugins/axios';
import type { UsuarioConfig } from '../types/menu.types';

export default {
  /**
   * Obtém as informações do usuário logado, prestador associado e permissões.
   * Substitui os inicializadores dos ManagedBeans MbBoConfiguracaoUsuario e MbBoLogin.
   */
  async getConfiguracaoUsuario(): Promise<UsuarioConfig> {
    const response = await axios.get<UsuarioConfig>('/usuarios/configuracao');
    return response.data;
  },

  /**
   * Baixa o relatório de Lista de Presença.
   * Substitui <p:fileDownload value="#{mbListaPresenca.imprimirRelatorio()}" />
   */
  async imprimirRelatorioPresenca(): Promise<Blob> {
    const response = await axios.get('/relatorios/lista-presenca', {
      responseType: 'blob' // Necessário para manipular o download do arquivo
    });
    return response.data;
  }
};
